import { FETCH_HELP_CONTENT } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case FETCH_HELP_CONTENT:
      return action.payload
    default:
      return state;
  }
}